module.exports = __webpack_public_path__ + "img/page1-bg.d52538f0.png";